import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0.15, as = "h1" }) {
  const Tag = as;
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function Marquee({ items, className = "" }) {
  return (
    <div className={`overflow-hidden border-y border-line bg-white py-5 ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-12 pr-12">
        {[...items, ...items].map((t, i) => (
          <span key={i} className="flex items-center gap-12">
            <span className="whitespace-nowrap font-serif text-xl italic text-stone-600 md:text-2xl">{t}</span>
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-terracotta" />
          </span>
        ))}
      </div>
    </div>
  );
}

export function SectionHeading({ eyebrow, title, intro, align = "left", dark = false }) {
  return (
    <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <p className={`label-eyebrow ${dark ? "text-terracotta-soft" : ""}`} data-testid="section-eyebrow">{eyebrow}</p>}
      <h2 className={`mt-3 font-serif text-3xl leading-[1.12] tracking-tight sm:text-4xl lg:text-[2.75rem] ${dark ? "text-cream" : "text-obsidian"}`}>
        {title}
      </h2>
      {intro && <p className={`mt-5 text-base leading-relaxed ${dark ? "text-stone-300" : "text-stone-600"}`}>{intro}</p>}
    </Reveal>
  );
}
